import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { Route, Routes, HashRouter } from 'react-router-dom';
import "./i18n";

import MainPage from './renderer/pages/main/mainPage.js';
import TopMenu from './renderer/components/topMenu/menu.js';
import { Toast } from 'primereact/toast';

import 'primereact/resources/themes/saga-blue/theme.css';  //theme
import 'primereact/resources/primereact.min.css';          //core css
import 'primeicons/primeicons.css';                        //icons
import 'primeflex/primeflex.css';

import './renderer/style/index.css';

//redux
import { PrimeReactProvider } from 'primereact/api';

const ProjectMainComponent = () => {
  const toast = useRef(null);

  return (
      <>
        <div className='h-screen flex flex-column'>
          <Toast ref={toast} />
          <TopMenu/>
          
          <div id="index">
            <Routes>
              <Route exact path="/" element={<MainPage toastRef={toast}/>}/>
            </Routes>
          </div>

        </div>
      </>
  );
  
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PrimeReactProvider value={{hideOverlaysOnDocumentScrolling: true}}>
    <HashRouter>
      <ProjectMainComponent />
    </HashRouter>
  </PrimeReactProvider>
);